import React, { useState, useContext } from 'react';
import { InfoHeader, Detail as DetailComponent, useDrawer, SplitButton } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";

const dataProviderName = 'persons/person';
const drawerRouteBase = 'persons';

const Detail = (params) => {
    const { t } = useTranslation();
    const { activate, close: closeDrawer } = useDrawer();

    const { userCapabilities, existingModules, appConfiguration } = useContext(AppContext);


    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);

    const [assignedServices, setAssignedServices] = useState([])

    const { modelName, detailConfig } = existingModules[dataProviderName]

    // Ricerco i servizi collegati per poi passare il filtro al bottone di aggiunta costi
    const loadAssignedServices = (response) => {
        const person = response?.item?.data;

        let services = [];

        const direct = person?.services?.map((service) => service._id).flat(Infinity);
        const employment = person?.employment?.services?.map((service) => service._id).flat(Infinity);
        const car = person?.employment?.pools?.map((pool) => pool.car?.services?.map((service) => service._id)).flat(Infinity);
        const contract = person?.employment?.pools?.map((pool) => pool.car?.contract?.services?.map((service) => service._id)).flat(Infinity);

        if (typeof direct != 'undefined') services.push(...direct);
        if (typeof employment != 'undefined') services.push(...direct);
        if (typeof car != 'undefined') services.push(...car);
        if (typeof contract != 'undefined') services.push(...contract);

        setAssignedServices(services.filter(item => item !== undefined));
    };

    useLoadOne({ loadOne, params, reloadCounter, onSuccess: loadAssignedServices })

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({ ...data, filters: params.filters }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    //FIX URGENTE PER IMPEDIRE VISUALIZZAZIONE DOCUMENTI
    if (process.env.REACT_APP_HIDE_DOCUMENTS && userCapabilities['auth/role.is_driver']) {
        const id = detailConfig.tabs.findIndex(item => item.name === 'linked_documents');
        if (id > -1) {
            detailConfig.tabs.splice(id, 1);
        }
    }

    //SE LA PERSONA NON HA RUOLI AZIENDALI NON POSSIAMO EDITARE I SERVIZI
    const tabid = detailConfig.tabs.findIndex(item => item.name === 'service_association');
    if (tabid > -1) {
        const fieldsetid = detailConfig.tabs[tabid].fieldsets.findIndex(item => item.name === 'services');
        if (fieldsetid > -1) {
            const field = detailConfig.tabs[tabid].fieldsets[fieldsetid].fields['services'];

            if (field && !item?.data?.employment) {
                field.disabled = true
                field.relation.relationAssociator = 'hidden'
                field.relation.relationDissociator = 'hidden'
                field.label = t('Services (editing disabled because missing Company Role)');
            } else if (field && item?.data?.employment) {
                field.disabled = false
                field.relation.relationAssociator = 'services/create'
                field.relation.relationDissociator = 'persons/serviceDissociation'
                field.label = t('Services');
            }
        }
    }

    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{ ...item?.data }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={item?.data?.name == ' ' ? t('New Person') : item?.data?.name}
                header={
                    <InfoHeader
                        view={appConfiguration?.infoheaders?.person ?? 'person'}
                        item={item?.data}
                    />
                }
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                disabled: userCapabilities && !userCapabilities['cars/cost.create'],
                                icon: "faMoneyBill",
                                label: t('Add Cost'),
                                onClick: () => {
                                    activate('costs/create', {
                                        detailStack: params.detailStack ?? {},
                                        person:  item?.data,
                                        legalEntity: item?.data?.employment?.legalEntity,
                                        detailConfigOverride: {
                                            "tabs": [
                                                {
                                                    "fieldsets": [
                                                        {
                                                            "fields": {
                                                                "service": {
                                                                    "type": "servicelist",
                                                                    "className": "col-12",
                                                                    "hideTableToolbar": true,
                                                                    "filters": {
                                                                        "items": [
                                                                            {
                                                                                "field": "id", // usa id e non _id perché il server non cerca per ObjectID
                                                                                "operator": "isAnyOf",
                                                                                "value": assignedServices//["685c1345662493299202b860", "685c1345662493299202b861"]
                                                                            }
                                                                        ]
                                                                    },
                                                                },
                                                            }
                                                        }
                                                    ]
                                                }
                                            ]

                                        }
                                    })
                                }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.employmentassociation'],
                                icon: "faSuitcase",
                                label: t('Assign an Employment'),
                                onClick: () => { activate('employments/create', { person: item?.data, legalEntity: item?.data?.legalEntity }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.employmentdissociation'],
                                icon: "faSuitcase",
                                label: t('Terminate an Employment'),
                                onClick: () => {
                                    activate(drawerRouteBase + '/employmentDissociation', {
                                        employments: item?.data?.employments
                                    });
                                }
                            },
                            {
                                disabled: (userCapabilities && !userCapabilities[dataProviderName + '.serviceassociation']) || !item?.data?.employment,
                                icon: "faCreditCard",
                                label: t('Assign a Service'),
                                onClick: () => {
                                    activate('services/create', {
                                        assignedModel: "employee",
                                        person: item?.data,
                                        legalEntity: item?.data?.employment?.legalEntity,
                                        assignment_start_at: new Date()
                                    });
                                }
                            },
                            {
                                disabled: (userCapabilities && !userCapabilities[dataProviderName + '.servicedissociation']) || !item?.data?.employment,
                                icon: "faCreditCard",
                                label: t('Remove a Service'),
                                onClick: () => { activate(drawerRouteBase + '/serviceDissociation', { item: item }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.carassociation'],
                                icon: "faCar",
                                label: t('Assign a Car'),
                                onClick: () => { activate(drawerRouteBase + '/carAssociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.cardissociation'],
                                icon: "faCar",
                                label: t('Remove a Car'),
                                onClick: () => { activate(drawerRouteBase + '/carDissociation', { detailStack: params.detailStack ?? {} }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities['documents/document.genericfileassociation'],
                                icon: "faFolderUser",
                                label: t('Add Personal Document'),
                                onClick: () => { activate(drawerRouteBase + '/genericFileAssociation', { person: item?.data, multipart: true, filters: { data: { modelName: 'persons', _id: item?.data?._id, keyName: item?.data?.firstname + ' ' + item?.data?.lastname } } }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.configuratormanagement'],
                                icon: "faPencil",
                                label: t('Manage Configurator access'),
                                onClick: () => { activate(drawerRouteBase + '/configuratorManagementSingle', { person: item?.data }); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.notification'],
                                icon: "faEnvelope",
                                label: t('Notify'),
                                onClick: () => {
                                    activate(
                                        'wizards/notify',
                                        {
                                            items: [item.data.id],
                                            dataProviderName: dataProviderName
                                        },
                                        (data) => {
                                            if (!data?.success) return;
                                        }
                                    )
                                }
                            }
                        ]}
                    />
                ]}
                {...params}
            />
        </>
    )
}
export default Detail;


